import React, { useState } from 'react';
import styled from 'styled-components'
import { Link } from 'react-router-dom';
import ArrowDown from '../../../asset/icon/below.png';
import { infoKo, infoEn, companyKo, companyEn } from '../../../asset/policy/footerData';
import { useLanguageStore } from '../../../shared/store/languageStore';
import { Language } from '../../../shared/enum/EnumRepository';
import LanguageSelector from '../../../shared/component/LanguageSelector';
import { paddingBottomWithSafeArea } from '../../../shared/constants/safeArea';

const LeftBottomIslandMobile: React.FC = () => {
  const { language } = useLanguageStore();
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const info = language === Language.KR ? infoKo : infoEn;
  const company = language === Language.KR ? companyKo : companyEn;

  return (
    <>
      <Copyright>{info.copyright}</Copyright>
    <GnbSection>
      <CompanyInfo>
        <NavigationLinks>
          <NavLink to="/policy/terms">{info.termsOfService}</NavLink>
          <NavLink to="/policy/privacy">{info.privacyPolicy}</NavLink>
          <LanguageSelector />
          <ToggleInfoButton 
            $isInfoOpen={isInfoOpen}
            $backgroundImg={ArrowDown}
            onClick={() => setIsInfoOpen(prev => !prev)}
          />
        </NavigationLinks>
        <InfoWrapper $isInfoOpen={isInfoOpen}>
          <InfoLine>
            {company.name} | {info.ceo}: {company.ceo} | {info.businessNumber}: {company.businessNumber} | {info.communicationSalesRegistrationNumber}: {company.communicationSalesRegistrationNumber} | {info.email}: <UnderlinedLink>{company.email}</UnderlinedLink>
          </InfoLine>
          <InfoLine>
            {info.privacyManager}: {company.privacyManager} | {info.address}: {company.address} | {info.phone}: <UnderlinedLink>{company.phone}</UnderlinedLink>
          </InfoLine>
        </InfoWrapper>
      </CompanyInfo>
    </GnbSection>
    </>
  );
}

const GnbSection = styled.section`
  width: 100%;
  height: 0px;
  
  display: flex;
  flex-direction: column;
  user-select: none;
  background-color: transparent; 
  border-top: 0.5px solid ${({ theme }) => theme.colors.color_Gray_05};
`;

const Copyright = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;

  user-select: none;
  padding: 0 4px ${paddingBottomWithSafeArea('4px')} 4px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Footer_01};
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1vw 4vw 0 4vw;
`;

const NavigationLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
`;

const NavLink = styled(Link)`
  color: ${({ theme }) => theme.colors.color_Gray_04};
  text-decoration: none;
  ${({ theme }) => theme.typography.Footer_01};
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.color_Gray_03};
  }
`;


const ToggleInfoButton = styled.div<{ $isInfoOpen: boolean; $backgroundImg: string }>`
  width: clamp(8px, 1.5vw, 12px);
  height: clamp(8px, 1.5vw, 12px);
  background-image: url(${({ $backgroundImg }) => $backgroundImg});
  background-size: cover;
  background-position: center;
  cursor: pointer;
  transform: ${({ $isInfoOpen }) => $isInfoOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  opacity: ${({ $isInfoOpen }) => $isInfoOpen ? 0.4 : 0.8};
  transition: opacity 0.3s ease, transform 0.3s ease;
`;

const InfoLine = styled.div`
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Footer_02};
`;

const InfoWrapper = styled.div<{ $isInfoOpen: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  user-select: none;
  height: ${({ $isInfoOpen }) => $isInfoOpen ? 'clamp(50px, 12vh, 90px)' : '0px'};
  transition: height 0.3s ease;
  overflow: hidden;
  padding-top: 4px;
`;

const UnderlinedLink = styled.span`
  color: ${({ theme }) => theme.colors.color_Gray_05};
  text-decoration: underline;
`;




export default LeftBottomIslandMobile;
